import { useEffect, useState } from 'react';
import { getContentBySection } from '../../api/content';
import './About.css';

const DEFAULTS = {
  label: 'Quem somos',
  heading_linha1: 'Software com qualidade.',
  heading_linha2: 'Gestão com resultado.',
  body: 'A Gerenciar é uma Software House com mais de 15 anos de mercado, especializada em sistemas de gestão para empresas que precisam de eficiência real. Como braço tecnológico da ESB Corp, combinamos agilidade de startup com a solidez de uma holding presente em todo o Brasil.',
  pilar1_num: '01',
  pilar1_titulo: 'Solidez Corporativa',
  pilar1_desc: 'Respaldo de uma holding com atuação em 26 estados e +8.000 colaboradores. Isso é segurança e continuidade para o seu negócio.',
  pilar2_num: '02',
  pilar2_titulo: 'Especialização Setorial',
  pilar2_desc: 'Sistemas desenvolvidos com profundo conhecimento de saúde, financeiro, varejo e gestão de pessoas.',
  pilar3_num: '03',
  pilar3_titulo: 'Tecnologia Escalável',
  pilar3_desc: 'Arquitetura moderna que acompanha o crescimento da sua empresa, sem retrabalho e sem surpresas.',
};

const About = () => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    getContentBySection('about').then(data => {
      if (Object.keys(data).length > 0) {
        setContent(prev => ({ ...prev, ...data }));
      }
    }).catch(() => {});
  }, []);

  const pillars = [
    { num: content.pilar1_num, title: content.pilar1_titulo, desc: content.pilar1_desc },
    { num: content.pilar2_num, title: content.pilar2_titulo, desc: content.pilar2_desc },
    { num: content.pilar3_num, title: content.pilar3_titulo, desc: content.pilar3_desc },
  ];

  return (
    <section className="about" id="sobre">
      <div className="about__left">
        <div className="about__accent" aria-hidden="true" />
        <p className="g-label about__label">{content.label}</p>
        <h2 className="about__heading">
          {content.heading_linha1.replace(' qualidade.', '')} <em>qualidade.</em><br />
          {content.heading_linha2.replace(' resultado.', '')} <em>resultado.</em>
        </h2>
        <p className="about__body">{content.body}</p>
      </div>

      <div className="about__right">
        <ul className="about__pillars">
          {pillars.map(({ num, title, desc }) => (
            <li className="about__pillar" key={num}>
              <span className="about__pillar-num">{num}</span>
              <div>
                <strong className="about__pillar-title">{title}</strong>
                <p className="about__pillar-desc">{desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default About;